import { USER_SEGMENT_ENUM } from 'integration/resources/auth'

import { MultiplierValuesType, Tab } from '../RVCalculatorsSim.types'

export const rolesGR = [
  'GTE RELAC FINANC III (FIN)',
  'GTE RELAC FINANC II',
  'ESPEC COML FINANCEIRA I',
  'ESPEC COML FINANCEIRA II',
  'ESPEC COML FINANCEIRA III',
  'ESPEC RISCOS CREDITO III',
  'ESPEC RISCOS CREDITO I',
  'ESPEC INVESTIMENTOS II'
]

export const targets = [
  { id: '0', name: 'Especialista I', value: 1272 }, // B&S N7
  { id: '1', name: 'Especialista II e III', value: 1526 } // B&S N8
]

export const resultsTargets = [
  { id: '0', name: 'Especialista I', value: 2544 }, // B&S N7
  { id: '1', name: 'Especialista II e III', value: 3052 } // B&S N8
]

export const getTargetsBySegment = (_segment?: USER_SEGMENT_ENUM) => targets

export const getResultsTargetsBySegment = (_segment?: USER_SEGMENT_ENUM) => resultsTargets

export const performanceValues = [0, 5, 15, 30]

export const chargeGoalValues = [1, 2]

export const mobSPFValues = ['MOB', 'SPF', 'TABS recorrentes']

export const multiplierEspecValues: MultiplierValuesType = {
  2: { withInsurance: 1, withoutInsurance: 1 },
  3: { withInsurance: 1.4, withoutInsurance: 1.2 },
  4: { withInsurance: 2.3, withoutInsurance: 1.8 },
  5: { withInsurance: 4, withoutInsurance: 4 }
}

export const multiplierValues: MultiplierValuesType = {
  2: { withInsurance: 1, withoutInsurance: 1 },
  3: { withInsurance: 1.4, withoutInsurance: 1.2 },
  4: { withInsurance: 1.8, withoutInsurance: 1.4 },
  5: { withInsurance: 2.3, withoutInsurance: 1.8 },
  6: { withInsurance: 4.0, withoutInsurance: 4.0 }
}

export const resultMultiplierValues: MultiplierValuesType = {
  0: { withInsurance: 1, withoutInsurance: 1 },
  1: { withInsurance: 1.2, withoutInsurance: 1.1 },
  2: { withInsurance: 1.4, withoutInsurance: 1.2 },
  3: { withInsurance: 2, withoutInsurance: 1.5 },
  4: { withInsurance: 2.8, withoutInsurance: 2 },
  5: { withInsurance: 4, withoutInsurance: 3 }
}

export const indicatorsLines = [
  'Produção',
  'Cobrança',
  'TABS pagantes',
  'TABS recorrentes',
  'mobSPF',
  'Total'
]

export const indicatorsLinesLeader = [
  'Produção',
  'MOB',
  'TABS pagantes',
  'Gastos',
  'Cobrança',
  'mobSPF',
  'Total'
]

export const tabsConfig: Tab[] = [
  {
    id: 1,
    title: `Calculadora Bloco de Negócios`,
    subtitle: 'Simule seus ganhos de remuneração variável e compare com sua RV atual',
    observations: [
      `Este “SIMULADOR” deve ser utilizado para simples estimativas e para esclarecer eventuais pontos sobre o cálculo do programa de RV 2025. Ele não considera eventuais proporcionalidades nem representa critérios oficiais de elegibilidade, apuração e pagamento.`
    ]
  },
  {
    id: 2,
    title: 'Calculadora de Resultados',
    subtitle: 'Subtítulo contextualizando a calculadora.',
    observations: [
      `Este “SIMULADOR” deve ser utilizado para simples estimativas e para esclarecer eventuais pontos sobre o cálculo do programa de RV 2025. Ele não considera eventuais proporcionalidades nem representa critérios oficiais de elegibilidade, apuração e pagamento.`
    ]
  }
]
